import { ApiPostOrganizationsMergerResponse } from './api-post-organizations-merger.response';
import con from '../../../../../connection';

const path = '/merger'

export const merger = (url: string) => () => ({
  post: (param: { to_organization_code: string }) =>
    con.post<ApiPostOrganizationsMergerResponse>(url + path, param),
})